module.exports = __webpack_public_path__ + "static/media/good_morning.acf0a371.png";